import { useBrand } from "hooks/useBrand";
import React from "react";
import { useTranslation } from "react-i18next";

import styles from "../Register.module.css";

const RegisterHeader = () => {
	const { t } = useTranslation("accountsPage");
	const brand = useBrand();

	return (
		<header className={styles.header}>
			<h1 className={styles.title}>{t("register.title")}</h1>
			<p className={styles.subtitle}>{t("register.subtitle", brand)}</p>
		</header>
	);
};

export default RegisterHeader;
